import { render, staticRenderFns } from "./EditarMovimiento.vue?vue&type=template&id=00b40c8c&"
import script from "./EditarMovimiento.vue?vue&type=script&lang=ts&"
export * from "./EditarMovimiento.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports